<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">Thanks go to my sister and brother, Melanie and Ian Howarth, and also to Andy Moss and Phil Taylor, for proofreading the initial manuscript and for plot suggestions and edits.</p>
<p style="text-indent:0em;">Thanks to Austin Macauley Publishers for the editing and production carried out efficiently and effectively, also for their friendliness.</p>
<p style="text-indent:0em;">Thanks also go to Helen, my wife, for putting up with me disappearing for many hours to write the stories of Theo Newsome and his friends.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?318ec270